module.exports = new __parcel__URL__("name_screen_rect.8e39544e.png").toString();